<template>
  <div>
    <a-spin :spinning="loading3" :indicator="indicator">
      <vxe-toolbar>
        <template #buttons>
          <!-- <vxe-input
            v-model="filterName1"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent1"
          ></vxe-input> -->
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        show-overflow
        row-id="id"
        size="small"
        ref="xTable"
        :row-config="{ isCurrent: true, isHover: true, height: 35 }"
        :data="tableData3"
        align="center"
        header-align="center"
        class="my-sort"
        :column-config="{ isHover: true }"
        :sort-config="{
          showIcon: false,
          trigger: all,
          defaultSort: { field: 'score', order: 'desc' },
        }"
        @header-cell-click="headerCellClickEvent"
      >
        <vxe-column field="cellid" title="Cell ID" width="40%"> </vxe-column>
        <vxe-column field="celltype" title="Status"> </vxe-column>
        <vxe-column
          field="score"
          title="Perturbation score"
          sortable
          :formatter="formatPercentCell"
        >
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span>
          </template>
        </vxe-column>
        <template #empty>
          <span style="color: grey"> No more data! </span>
        </template>
      </vxe-table>
      <vxe-pager
        background
        size="small"
        :loading="loading3"
        :current-page="tablePage3.currentPage"
        :page-size="tablePage3.pageSize"
        :total="tablePage3.totalResult"
        :page-sizes="[10, 20, 50, 100]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          // 'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange3"
      >
      </vxe-pager>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  data() {
    return {
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      //全表搜索
      filterName1: "",
      tempdata: [],
      //分页
      getdata: null, //必须要生成这个data
      loading3: false,
      tableData3: [],
      tablePage3: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  mounted() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/publications_perturScore.php",
        {
          params: {
            datasetId: this.$route.query.datasetId,
            gene: this.$route.query.gene,
          },
        }
      )
      .then((response) => {
        //this.getdata = response.data;
        //清空之前选择的基因
        const convertedArray = [...response.data].sort(
          (a, b) => b.score - a.score
        );
        this.getdata = convertedArray;
        this.findList3(this.getdata);
      });
  },
  methods: {
    formatPercentCell({ cellValue }) {
      return String(parseFloat(cellValue).toFixed(3));
    },
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        if (column.order === "desc") {
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/publications_perturScore.php",
              {
                params: {
                  datasetId: this.$route.query.datasetId,
                  gene: this.$route.query.gene,
                },
              }
            )
            .then((response) => {
              //this.getdata = response.data;
              //清空之前选择的基因
              const convertedArray = [...response.data].sort(
                (a, b) => b.score - a.score
              );
              this.getdata = convertedArray;
              this.$refs.xTable.clearSort();
              this.findList3(this.getdata);
            });
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata = jiangxu;
          this.findList3(this.getdata);
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          var shengxu = this.getdata.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属升序排序
          this.getdata = shengxu;
          this.findList3(this.getdata);
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    // formatPercentCell({ cellValue }) {
    //   return String(parseFloat(cellValue).toFixed(2)) + "%";
    // },
    exportDataEvent() {
      const list = this.getdata;
      this.$refs.xTable.exportData({
        filename:
          "Predicted drugs by Perturb-seq datasets for " +
          this.$route.query.gene,
        type: "csv",
        isHeader: true,
        isFooter: true,
        data: list,
      });
    },
    findList3(data) {
      this.loading3 = true;
      setTimeout(() => {
        const list = data;
        this.loading3 = false;
        this.tablePage3.totalResult = list.length;
        this.tableData3 = list.slice(
          (this.tablePage3.currentPage - 1) * this.tablePage3.pageSize,
          this.tablePage3.currentPage * this.tablePage3.pageSize
        );
      }, 300);
    },
    handlePageChange3({ currentPage, pageSize }) {
      this.tablePage3.currentPage = currentPage;
      this.tablePage3.pageSize = pageSize;
      if (this.tempdata.length == 0) {
        this.findList3(this.getdata);
      } else {
        this.findList3(this.tempdata);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
